import { Component, OnInit } from '@angular/core';
import { RootService } from '../../service/root.service';
import { FAuth } from '../shared/fAuth';

import { TranslateService } from '@ngx-translate/core';
declare var lbd: any;
@Component({

    selector: 'auth-login',
    templateUrl: './auth-login.component.html',
    styleUrls: ['./auth-login.component.scss']
})
export class AuthLoginComponent implements OnInit {
    fAuth = new FAuth();
    user;
    constructor(public rootService: RootService, private translate: TranslateService) {
        this.user = null;
    }
    submittingForm: boolean = false;
    ngOnInit() {
        lbd.checkFullPageBackgroundImage();

        setTimeout(function () {
            // after 1000 ms we add the class animated to the login/register card
            $('.card').removeClass('card-hidden');
        }, 200)
    }
    onSubmit(form) {
        if (this.submittingForm) {
            return;
        }
        this.submittingForm = true;
        this.rootService.login(this.fAuth).subscribe(item => {
            this.submittingForm = false;
        }, err => {
            this.rootService.toast.showErrorCode(err.code);
            this.submittingForm = false;
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/auth-login/auth-login.component.ts